import { IconSearch } from '@maia/icons';
import { Input, Pagination, Table } from '@maia/ui';
import { debounce } from 'es-toolkit';
import { ActionDispatch, useEffect } from 'react';
import { useNoteTable } from './note-table.options';
import { PaginationDto } from '@maia/pagination';
import { NoteDto } from '@maia/shared';
import { FilterAction } from './../../../utils/filter/filter';

interface NotesTableProps {
  response?: Array<NoteDto>;
  pagination?: PaginationDto;
  state: {
    page?: number | undefined;
    limit?: 10 | 20 | 50 | undefined;
    sort?: string | undefined;
    filter?: string[] | undefined;
    search?: string | undefined;
  };
  setSearch: ActionDispatch<[action: FilterAction]>;
}

export function NoteTable(props: NotesTableProps) {
  const { response = [], pagination, state, setSearch } = props;
  const table = useNoteTable(response, pagination);
  const { sorting } = table.getState();

  useEffect(() => {
    setSearch({ type: 'setSort', payload: sorting });
  }, [setSearch, sorting]);

  const debouncedQuery = debounce(
    (payload: string) => setSearch({ type: 'setQuery', payload }),
    500,
  );

  return (
    <Table
      table={table}
      className="grid-cols-[auto_min-content_min-content_min-content]"
      filterSlot={
        <div className="flex gap-x-24">
          <Input
            icon={<IconSearch />}
            placeholder="Zoeken"
            className="w-full max-w-[550px] mr-auto"
            onChange={(event) => debouncedQuery(event.target.value)}
            defaultValue={state.search}
          />
        </div>
      }
      paginationSlot={
        pagination ? (
          <Pagination
            {...pagination}
            onLimitChange={(limit) =>
              setSearch({ type: 'setLimit', payload: limit })
            }
            onPageChange={(page) =>
              setSearch({ type: 'paginate', payload: page })
            }
          />
        ) : null
      }
    />
  );
}
